import React, { ReactElement } from 'react';
import { useRouter } from 'next/router';
import type { Route } from 'next';
import Link from 'next/link';
import classNames from 'classnames/bind';

import { RouteType } from 'components/Header/Header.types';

import styles from 'components/Header/Header.module.scss';

const cn = classNames.bind(styles);

interface LinksGroupProps {
  groupLink: RouteType[];
  label: string;
  index: number;
  isMobile: boolean;
  isActive: boolean;
  link: string;
  changeSelectedItem(argument: number | null): void;
  setIsUserPopupActive: () => void;
};

const LinksGroup = ({
  groupLink,
  label,
  index,
  isActive,
  isMobile,
  link,
  changeSelectedItem,
  setIsUserPopupActive,
}: LinksGroupProps): ReactElement => {
  const router = useRouter();

  const clickItemHandler = (argument: number) => {
    if (isActive) {
      changeSelectedItem(null);
      return;
    }

    changeSelectedItem(argument);
  };

  return (
    <>
      {!isMobile ? (
        <div className={cn('header__nav-item--sublink')}>
          <Link
            className={cn('header__nav-item-label-box')}
            href={link as Route}
          >
            {label}
          </Link>
          <ul className={cn('header__sublink')}>
            {groupLink.map(({ label, link }, index) => {
              return (
                <React.Fragment key={`${label}_${index}`}>
                  <Link
                    className={cn('header__sublink-link')}
                    href={link}
                  >
                    {label}
                  </Link>
                </React.Fragment>
              );
            })}
          </ul>
        </div>
      ) : (
        <>
          <div className={cn('header__nav-item--sublink', { 'mobileActiveLink': router.pathname === link }, `${isActive && 'active'}`)}>
            <Link
              href={link as Route}
              onClick={() => {
                setIsUserPopupActive();
                clickItemHandler(index);
              }}
            >
              {label}
            </Link>
            <div className="mobile-arrow-wrapper" onClick={() => clickItemHandler(index)}>
              <div className="mobile-arrow"></div>
            </div>
          </div>

          <div className={cn('header__sublink-box', `${!isActive || 'active'}`)}>
            {groupLink.map(({ label, link }, index) => {
              return (
                <React.Fragment key={`${label}_${index}`}>
                  <Link
                    className={cn('header__sublink-link', { 'mobileActiveLink': router.pathname === link })}
                    href={link}
                    onClick={setIsUserPopupActive}
                  >
                    {label}
                  </Link>
                </React.Fragment>
              );
            })}
          </div>
        </>
      )}
    </>
  );
};

export { LinksGroup };
